import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}


export function SmallLoadingSpinner() {
  return (
    <div className="small-spinner-container">
      <div className="small-loading-spinner"></div>
    </div>
  );
}